import { CSSProperties, forwardRef } from 'react';
import { Control, Controller, FieldError, FieldValues } from 'react-hook-form';

import Checkmark from 'assets/list-checkmark.svg';
import { Visible } from 'coreOld/components';

import {
  CheckboxContainer,
  HiddenCheckbox,
  Icon,
  Label,
  StyledCheckbox,
} from './checkboxInputStyle';

interface IProps {
  control?: Control<FieldValues, object>;
  error?: FieldError;
  name?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  id?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  title?: string;
  style?: CSSProperties;
  isLoading?: boolean;
}

const CheckboxInputWithControllerView = forwardRef(function CheckboxInputWithControllerView(
  {
    control,
    error,
    defaultChecked = false,
    checked,
    disabled,
    label,
    onChange,
    id,
    title,
    style,
    name,
    isLoading = false,
  }: IProps,
  ref
) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CheckboxContainer disabled={disabled} htmlFor={id} style={style}>
          <HiddenCheckbox
            name={name}
            title={title}
            ref={ref}
            type="checkbox"
            id={id}
            value={field.value}
            defaultChecked={defaultChecked || false}
            checked={field.value || false}
            onChange={(event) => {
              field.onChange(event.target.checked);

              onChange && onChange(event);
            }}
            disabled={disabled || isLoading}
          />

          <StyledCheckbox checked={checked || defaultChecked || field.value} error={Boolean(error)}>
            <Icon src={Checkmark} />
          </StyledCheckbox>

          <Visible when={Boolean(label)}>
            <Label>{label}</Label>
          </Visible>
        </CheckboxContainer>
      )}
    />
  );
});

export default CheckboxInputWithControllerView;
